//
// 开关
// ============================================================
import Ns from "./utility";

const Count = () => {
    new Ns({
        el: ".count-wrapper",
        eventHandle: [{
            type: "click",
            entrust: ".count-icon-minus",
            callback:  function (ev) {
                if(ns(this).parents(".count-wrapper").hasClass("disabled")) return;
                let countQuantity= Number(ns(this).next().text());
                let minValue = ns(this).parents(".count-wrapper").attr("data-count-min-value");
                if (minValue && countQuantity == 1 && minValue == 0) {
                    ns(this).next().text("0");
                    ns(this).parents(".count-wrapper").addClass("unactive");
                    setTimeout( () => ns(this).parents(".count-wrapper").removeClass("unactive").removeClass("active"), 500)
                }else {

                    if (countQuantity == 1) {
                        ns(this).addClass("color-gray-light");
                    }else {
                        countQuantity -= 1;
                        ns(this).next().text(countQuantity).next().removeClass("color-gray-light");
                    }
                }

                return true;
            }
        }, {
            type: "click",
            entrust: ".count-icon-plus",
            callback:  function (ev) {
                if(ns(this).parents(".count-wrapper").hasClass("disabled")) return;
                let countQuantity= Number(ns(this).prev().text());
                let maxValue = ns(this).parents(".count-wrapper").attr("data-count-max-value");
                if (maxValue && countQuantity >= maxValue) {
                    ns(this).addClass("color-gray-light");
                }else {
                    if(countQuantity == 0) {
                        ns(this).parents(".count-wrapper").addClass("active");
                    }

                    countQuantity += 1;
                    ns(this).prev().text(countQuantity).prev().removeClass("color-gray-light");
                }



                return true;
            }
        }],
        load() {
            Ns.each(ns(this).find(".count-quantity").get(), item => {
                if (ns(item).text() >= 1) {
                    ns(item).parents(".count-wrapper").addClass("active");
                }
            });
        },
    });
};

module.exports = Count;


// WEBPACK FOOTER //
// src/js/count.js